export default __webpack_public_path__ + "static/banner-8c5818f380bd0bedb11c63b3b7515548.png";